import {Address} from "./base";
import {EntitySearchableProps} from "./search";


export enum CompanyType {
    builder = "builder",
    developer = "developer",
    broker = "broker",
    not_set = "not_set",
}
/**
 * Minimal company representation for cards and links.
 * */
export interface CompanyBase {
    company_type: string;
    name: string;
    id: string;
}


export interface CompanyProfile extends CompanyBase {
    description: string;
    logo: string;
    address: Address;
    phone: string;
    email: string;
    website: string;
}

export interface MarketParticipation {
    sector: string ;
    subsector: string | null;
    project_size_min: number;
    project_size_max: number;
}


export interface UnionAffiliationItem {
    sector: string;
    trade: string;
    affiliation: string;
}


export interface BuilderProfile extends CompanyProfile {
    markets: MarketParticipation[];
    construction_types: string[];
    regions: string[]; // this might be geojson regions

    union_affiliation: UnionAffiliationItem[];

    revenue: number | null;
    founded: number | null;
    employee_count: number | null;
    bonding_capacity: number | null;
    facts: string[]
}


export interface DeveloperProfile extends CompanyProfile {
    // nothing here on purpose
}

